import { render, staticRenderFns } from "./element1.vue?vue&type=template&id=2676a93d&scoped=true"
import script from "./element1.vue?vue&type=script&lang=js"
export * from "./element1.vue?vue&type=script&lang=js"
import style0 from "./element1.vue?vue&type=style&index=0&id=2676a93d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676a93d",
  null
  
)

export default component.exports